/**
 * Created by Ivan on 14.11.2025
 */

const LevelMasteryLevelsAdapter = {
    SubscribeToEvents: function () {
        if (!cleverapps.config.features.includes("levelmastery")) {
            return;
        }

        cleverapps.missionManager.on("addLevelMasteryBar", () => {
            const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_LEVEL_MASTERY);
            if (mission && mission.isRunning()) {
                LevelMasteryView.createOnScene(mission.logic);
            }
        });

        cleverapps.missionManager.on("complete", (mission) => {
            if (mission.type !== Mission.TYPE_LEVEL_MASTERY) {
                return;
            }

            const scene = cleverapps.Scenes.GetRunningScene();
            if (scene && scene.levelMastery) {
                scene.levelMastery.removeFromParent();
                scene.levelMastery = undefined;
            }

            cleverapps.focusManager.removeControl("levelmastery_progress");
        });

        cleverapps.missionManager.on("levelMasteryRewardCollect", () => {
            const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_LEVEL_MASTERY);
            const scene = cleverapps.Scenes.GetRunningScene();
            cleverapps.focusManager.display({
                focus: "LevelMasteryReward",
                control: ["levelmastery_progress"],
                actions: [
                    function (f) {
                        if (scene.levelMastery) {
                            scene.levelMastery.rewardAnimation(f);
                        } else {
                            f();
                        }
                    },

                    function (f) {
                        const stageReward = mission.logic.getCurrentReward();
                        const isPrizeBox = stageReward.listRewards().length > 1;

                        const flyIcon = cleverapps.persist.acceptNode("levelMasteryReward");
                        const shine = cleverapps.persist.acceptNode("levelMasteryRewardShine");
                        cleverapps.eventBus.on("window_shown", () => {
                            if (!scene.levelMastery) {
                                return;
                            }

                            if (isPrizeBox) {
                                if (flyIcon) {
                                    flyIcon.runAction(new cc.Sequence(
                                        new cc.ScaleTo(0.3, 0).easing(cc.easeBackIn()),
                                        new cc.RemoveSelf()
                                    ));
                                }
                                if (shine) {
                                    shine.setAnimation(0, "close", false);
                                    shine.setCompleteListenerRemove();
                                }
                                return;
                            }

                            const window = cleverapps.focusManager.currentWindow();
                            const windowReward = window.rewardsList.targets[0];

                            windowReward.icon.removeFromParent(true);
                            windowReward.shine.removeFromParent();

                            flyIcon.replaceParentSamePlace(window, { keepScale: true });
                            shine.replaceParentSamePlace(window, { keepScale: true });

                            windowReward.icon = flyIcon;
                            cleverapps.timeouts.setTimeout(() => {
                                windowReward.shine = shine;
                            }, 1000);

                            const text = windowReward.text;
                            const textParentOrigin = text.parent;
                            text.replaceParent(flyIcon);
                            text.setPosition(flyIcon.width / 2, -40);
                            text.replaceParentSamePlace(textParentOrigin);
                        }, flyIcon);

                        new RewardWindow(stageReward, {
                            shine: false
                        });

                        cleverapps.focusManager.onceNoWindowsListener = f;
                    },

                    function (f) {
                        mission.logic.updateStage();

                        if (!mission.isCompleted() && scene.levelMastery) {
                            scene.levelMastery.nextRewardAnimation(f);
                            return;
                        }

                        cleverapps.shadow.hide();
                        f();
                    }
                ]
            });
        });
    }
};

cleverapps.whenAllInitialized(() => LevelMasteryLevelsAdapter.SubscribeToEvents());